import {observer} from "mobx-react-lite";
import React, {useEffect, useRef, useState} from "react";
import {useAppState, useRootStore, useUserState} from "@stores/AppStateContext";

import type {PaymentGateway} from "../../../../checkout/types";

import {PlaceholderPaymentGateway} from "../../../../checkout/providers/base/PlaceholderPaymentGateway";
import {destroyPaymentGateway, getPaymentGateway} from "../../../../checkout/initializePaymentGateway";

import {SeatManager} from "../../../../services/SeatManager";

export const CheckoutModal = observer((
    {}
) => {
    const appState = useAppState();
    const rootStore = useRootStore();
    const userState = useUserState();
    const [isReady, setIsReady] = useState(false);
    const paymentGatewayRef = useRef<PaymentGateway | null>(null);
    const activeModal = appState.topModal;

    useEffect(() => {
        const client = userState?.dsManager?.clientAR.row;
        if (!client || !userState) {
            throw new Error('client or userState not found');
        }
        SeatManager.getSeatUsage(userState, true).then(seatUsage => {
            if (paymentGatewayRef.current === null) {
                paymentGatewayRef.current = new PlaceholderPaymentGateway(userState, client, seatUsage);
            }

            if (!isReady && rootStore.isReady) {
                const currentLocale = rootStore.currentLocale;
                
                getPaymentGateway(client, currentLocale, userState).then((paymentGateway) => {
                    paymentGateway.setCheckoutInput(paymentGatewayRef.current!.checkoutInput);
                    paymentGatewayRef.current = paymentGateway;
                    setIsReady(true);
                })
            }
        });
        return () => {
            destroyPaymentGateway();
        }
    }, [rootStore.isReady, activeModal, isReady, userState]);

    if (!paymentGatewayRef.current) {
        return null;
    }

    const CheckoutContent = paymentGatewayRef.current!.CheckoutContent;
    return (
        <CheckoutContent key={`r${isReady}`} paymentGateway={paymentGatewayRef.current}/>
    )
});
